module.exports = __webpack_public_path__ + "img/FUTURE_Typo_Artefakt_2022_2.b6cf0f78.svg";